/** 备用复制方法 */
export function fallbackCopyToClipboard(text, successMessage = '坐标已复制到剪贴板！') {
  try {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
    alert(successMessage);
  } catch (err) {
    console.error('备用复制方法失败:', err);
    alert('复制失败，请手动复制坐标');
  }
}

/** 复制坐标到剪贴板 */
export function copyToClipboard(text) {
  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(text).then(() => {
      alert('坐标已复制到剪贴板！');
    }).catch(err => {
      console.error('复制坐标失败:', err);
      fallbackCopyToClipboard(text);
    });
  } else {
    fallbackCopyToClipboard(text);
  }
}
